import {Button, GrayButton} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {routes} from '@/utils/const';
import {LoadingOutlined} from '@ant-design/icons';
import {faFileChartColumn} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Checkbox as AntdCheckbox, Form, Popover, Spin, Tooltip} from 'antd';
import {useState} from 'react';
import styled from 'styled-components';
import {TechnicalsViewSwitcher} from '../../Common/ViewSwitcher';
import {TechnicalScore} from './TechnicalScore';
import {Checkbox} from '@/components/common-components/v2';
import {observer} from 'mobx-react';

interface Props {
  changeView: () => void;
}

export const HeaderSection = observer(({changeView}: Props) => {
  const [auditLoader, setAuditLoader] = useState(false);
  const [onPageAuditPopoverVisible, setOnPageAuditPopoverVisible] = useState(false);

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');
  const {contentAuditStore: {loadContentAudit, setNewRecordId}} = useStore('');

  const antIconSecond = <LoadingOutlined style={{fontSize: 14, color: '#7f4ead'}} spin />;

  const [form] = Form.useForm();

  const onRunPageAudit = async (values: any) => {
    if (!values['target-keywords'] || !values['target-keywords'].length) return;

    if (currentPage?.content?.importedFromUrl) {
      setAuditLoader(true);
      const countryCodeToUse = {
        countryCode: currentPage.content.countryCode,
        location: currentPage.content.location,
        locationId: currentPage.content.locationId,
      };

      const getId = await loadContentAudit(currentPage.content.importedFromUrl, values['target-keywords'], countryCodeToUse, currentPage.content.shouldUseHeadlessBrowser);
      if (getId?.id) {
        setAuditLoader(false);
        setNewRecordId(getId.id);
        window.open(`${window.location.origin}/${routes.onPageAuditDetails}/${getId.id}`, '_blank');
      }
      setAuditLoader(false);
    }
  };

  return <Container>
    <TopSeactionContainer>
      <TechnicalsViewSwitcher changeView={changeView} />
      {currentPage?.feTargetKeywords?.length ? <Popover
        overlayInnerStyle={{width: 300}}
        destroyTooltipOnHide={true}
        visible={onPageAuditPopoverVisible}
        content={<PopoverWrapper>
          <PopoverTitle>Select 1 to 3 Target Keywords</PopoverTitle>
          <FormStyled onFinish={onRunPageAudit}
            form={form}
            initialValues={{
              'target-keywords': [currentPage?.getUniqueKeywords[0]],
            }}>
            <Form.Item name='target-keywords'
              rules={[() => ({
                validator(_, value) {
                  const existingValues = form.getFieldsValue(true);
                  if (!value || !existingValues['target-keywords']?.length) return Promise.reject(new Error('Please select at least 1 Target Keyword.'));
                  if (existingValues['target-keywords']?.length && existingValues['target-keywords']?.length > 3) return Promise.reject(new Error('You can use maximum of 3 Target Keywords.'));

                  return Promise.resolve();
                },
              })]}>
              <AntdCheckbox.Group>
                <PopoverKwContainer>
                  {currentPage?.getUniqueKeywords?.map((kw, idx) => {
                    return <Checkbox value={kw} key={idx} style={{lineHeight: '32px'}}>
                      {kw}
                    </Checkbox>;
                  })}
                </PopoverKwContainer>
              </AntdCheckbox.Group>
            </Form.Item>
            <PopoverBtnContainer>
              <GrayButton style={{marginLeft: 0, marginBottom: 24}} onClick={() => setOnPageAuditPopoverVisible(false)}>Cancel</GrayButton>
              <Form.Item>
                <Button type='primary' htmlType='submit'>
              Confirm
                </Button>
              </Form.Item>
            </PopoverBtnContainer>
          </FormStyled>
        </PopoverWrapper>}>
        <RunPageAuditBtn onClick={() => setOnPageAuditPopoverVisible(!onPageAuditPopoverVisible)} color='neonBlue' variant='ghost' mode='dark'>
          {auditLoader ? <Spin indicator={antIconSecond} /> : <FontAwesomeIcon icon={faFileChartColumn} />}
          <BtnText>Run Complete Onpage Audit</BtnText>
        </RunPageAuditBtn>
      </Popover> : <Tooltip title={'Please add at least 1 Target Keyword.'} placement='topLeft'>
        <RunPageAuditBtn color='neonBlue' variant='ghost' mode='dark'>
          {auditLoader ? <Spin indicator={antIconSecond} /> : <FontAwesomeIcon icon={faFileChartColumn} />}
          <BtnText>Run Complete Onpage Audit</BtnText>
        </RunPageAuditBtn>
      </Tooltip> }
    </TopSeactionContainer>

    <TechnicalScore />
  </Container>;
});

const Container = styled.div`
  width: 100%;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 10px;
`;

const TopSeactionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const RunPageAuditBtn = styled(Button)`
  color: #4881f0 !important;
  cursor: pointer;
  display: flex;
  margin-bottom: 20px;
`;

const BtnText = styled.div`
  margin-left: 5px;
  display: inline-block;
  color: #34AEF3 !important;
  font-size: 12px;

  // &:hover {
  //   text-decoration: underline;
  // }
`;

const PopoverWrapper = styled.div`

`;

const PopoverTitle = styled.div`
  font-weight: 600;
  margin-bottom: 20px;
`;
const PopoverKwContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const FormStyled = styled(Form)`
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }

  .ant-checkbox-wrapper {
    line-height: 22px !important;
  }

  .ant-form-item-explain-error {
    font-size: 12px;
  }
`;

const PopoverBtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

